

<mat-card>
  <mat-card-header>
    <h3>Analise de Inscrições  </h3>
  </mat-card-header>

  <mat-card-content>

    <form [formGroup]="form">

      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

      <mat-form-field class="curso">
        <mat-label><strong>Curso :</strong></mat-label>
        <mat-select name="curso" formControlName="curso">
          <mat-optgroup label="curso">
            <mat-option value="" >TODOS OS CURSOS</mat-option>
            <mat-option value="ASSISTENCIA DE ENFERMAGEM EM ONCOLOGIA PEDIATRICA" >ASSISTENCIA DE ENFERMAGEM EM ONCOLOGIA PEDIATRICA</mat-option>
            <mat-option value="CIRURGIA PEDIATRICA EM ONCOLOGIA" >CIRURGIA PEDIATRICA EM ONCOLOGIA</mat-option>
            <mat-option value="CUIDADOS ONCOLOGICOS CIRURGICOS DO CANCER GASTROINTESTINAL - PERFIL RADIOLOGIA" >CUIDADOS ONCOLOGICOS CIRURGICOS DO CANCER GASTROINTESTINAL - PERFIL RADIOLOGIA</mat-option>
            <mat-option value="DERMATOLOGIA EM ONCOLOGIA" >DERMATOLOGIA EM ONCOLOGIA</mat-option>
            <mat-option value="ENDOCRINOLOGIA EM ONCOLOGIA" >ENDOCRINOLOGIA EM ONCOLOGIA</mat-option>
            <mat-option value="NEUROCIRURGIA EM ONCOLOGIA" >NEUROCIRURGIA EM ONCOLOGIA</mat-option>
            <mat-option value="ONCOLOGIA ORTOPEDICA" >ONCOLOGIA ORTOPEDICA</mat-option>
            <mat-option value="PESQUISA CLINICA EM CANCER COM ENFASE NA INVESTIGACAO CLINICA EM ONCOLOGIA" >PESQUISA CLINICA EM CANCER COM ENFASE NA INVESTIGACAO CLINICA EM ONCOLOGIA</mat-option>
            <mat-option value="RADIOLOGIA INTERVENCIONISTA E ANGIORRADIOLOGIA" >RADIOLOGIA INTERVENCIONISTA E ANGIORRADIOLOGIA</mat-option>
            <mat-option value="RADIOLOGIA MAMARIA" >RADIOLOGIA MAMARIA</mat-option>
            <mat-option value="TRANSPLANTE DE MEDULA OSSEA" >TRANSPLANTE DE MEDULA OSSEA</mat-option>
            <mat-option value="UROLOGIA EM ONCOLOGIA" >UROLOGIA EM ONCOLOGIA</mat-option>

          </mat-optgroup>
        </mat-select>
      </mat-form-field>

      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

      <button mat-mini-fab color="primary" class="upload-btn" (click)="criarFiltro()"><mat-icon>filter</mat-icon></button>

      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;




      <button type="button" mat-raised-button name="retorna" color="primary" (click)="retorna()" >
        Retorna
      </button>



      <table mat-table [dataSource]="dataSource" matSort>


        <ng-container matColumnDef="classificacao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> CLASSIF </th>
          <td mat-cell *matCellDef="let e"> {{e.classificacao}} </td>
        </ng-container>

        <ng-container matColumnDef="cpf">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> CPF </th>
          <td mat-cell *matCellDef="let e"> {{e.cpf}} </td>
        </ng-container>

        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> NOME </th>
          <td mat-cell *matCellDef="let e"> {{e.nome}} </td>
        </ng-container>

        <ng-container matColumnDef="curso">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> CURSO </th>
          <td mat-cell *matCellDef="let e"> {{e.curso}} </td>
        </ng-container>


        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> STATUS </th>
          <td mat-cell *matCellDef="let e"> {{e.status}} </td>
        </ng-container>

        <ng-container matColumnDef="acao" align="center center">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after" align="center center"> Acões </th>
          <td mat-cell *matCellDef="let e">

            <button mat-icon-button (click)="goToConvoca(e)" title="Convocação">
              <mat-icon>warning</mat-icon>
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button mat-icon-button (click)="goToAnalise(e)" title="Analise">
              <mat-icon>search</mat-icon>
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button mat-icon-button (click)="goToEmail(e)" title="Contato">
              <mat-icon>email</mat-icon>
            </button>

          </td>
          </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunas"></tr>
        <tr mat-row *matRowDef="let row; columns: colunas;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </form>
  </mat-card-content>
</mat-card>


<p>
<p>
<p>
